import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const MukemelPerfume = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/perfume") {
      navigate("/perfume", { replace: true });
    }
  }, [location, navigate]);

  return null;
};

export default MukemelPerfume;
